import { render, staticRenderFns } from "./DealerKits.vue?vue&type=template&id=5aa3d735&"
import script from "./DealerKits.vue?vue&type=script&lang=js&"
export * from "./DealerKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports